import { Box } from '@chakra-ui/react'
import { GoogleMap, Marker } from '@react-google-maps/api'
import { useCallback, useRef } from 'react'

import { LoadingBlock } from '../Loading'
import { useGoogleMaps } from './GoogleMapsProvider'

const DEFAULT_CENTER = { lat: -23.5505, lng: -46.6333 }
const CONTAINER_STYLE = { width: '100%', height: '300px' }

interface IProps {
  latitude: number | null
  longitude: number | null
  onPositionChange: (lat: number, lng: number, placeId?: string) => void
}

export function EventLocationMap({ latitude, longitude, onPositionChange }: IProps) {
  const { isLoaded } = useGoogleMaps()
  const mapRef = useRef<google.maps.Map | null>(null)

  const center = latitude && longitude ? { lat: latitude, lng: longitude } : DEFAULT_CENTER

  const handleMarkerDragEnd = useCallback(
    (e: google.maps.MapMouseEvent) => {
      const lat = e.latLng?.lat()
      const lng = e.latLng?.lng()
      if (lat !== undefined && lng !== undefined) {
        onPositionChange(lat, lng)
      }
    },
    [onPositionChange]
  )

  const handleMapClick = useCallback(
    (e: google.maps.MapMouseEvent & { placeId?: string }) => {
      const lat = e.latLng?.lat()
      const lng = e.latLng?.lng()
      const clickedPlaceId = e.placeId
      if (lat !== undefined && lng !== undefined) {
        onPositionChange(lat, lng, clickedPlaceId)
      }
    },
    [onPositionChange]
  )

  if (!isLoaded) {
    return <LoadingBlock h="300px" bg="gray.100" borderRadius="md" entity="mapa" />
  }

  return (
    <Box borderRadius="md" overflow="hidden">
      <GoogleMap
        mapContainerStyle={CONTAINER_STYLE}
        center={center}
        zoom={latitude && longitude ? 16 : 12}
        onClick={handleMapClick}
        onLoad={(map) => {
          mapRef.current = map
        }}
        options={{
          streetViewControl: false,
          mapTypeControl: false
        }}
      >
        <Marker
          position={latitude && longitude ? { lat: latitude, lng: longitude } : DEFAULT_CENTER}
          draggable
          onDragEnd={handleMarkerDragEnd}
        />
      </GoogleMap>
    </Box>
  )
}
